import { render, staticRenderFns } from "./ReportInfo.vue?vue&type=template&id=447af504&scoped=true&"
import script from "./ReportInfo.vue?vue&type=script&lang=js&"
export * from "./ReportInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReportInfo.vue?vue&type=style&index=0&id=447af504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447af504",
  null
  
)

export default component.exports